import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {UserInfoService} from "../../user-info.service";
import {Subscription} from "rxjs";

declare const $: any;

@Component({
    selector: 'app-login-dialog',
    templateUrl: './login-dialog.component.html',
    styleUrls: ['./login-dialog.component.scss'],
    standalone: false
})
export class LoginDialogComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  @ViewChild('loginModal') loginModalEl: ElementRef;

  constructor(public userInfo: UserInfoService) {
  }

  ngOnInit() {
    this.subscriptions.push(this.userInfo.loginStateChanged.subscribe(loggedIn => {
      if (!loggedIn) {
        this.showModal();
      } else {
        this.hideModal();
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  showModal() {
    const el = $(this.loginModalEl.nativeElement);
    el.modal({closable: false}).modal('show');
  }

  hideModal() {
    const el = $(this.loginModalEl.nativeElement);
    if (el.modal('is active')) {
      el.modal('hide');
    }
  }

  // for testing
  expireSession() {
    this.userInfo.expireSession();
  }
}
